import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostCrecaTradesRequestModel, PostCrecaTradesResponseModel } from "@/features/accounts/creca/services/update-trades-model";

export class UpdateCrecaTradesApi {
  /**
   * クレカ明細更新API
   */
  public updateCrecaTrades = async (
    param: PostCrecaTradesRequestModel
  ): Promise<PostCrecaTradesResponseModel> => {
    const path = `/api/crecaaccounts/crecas/aggregate`;
    const res = await ApiClient.instance.post<PostCrecaTradesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
